import React from 'react';
import { authService } from '../../services';
import PlantDashboard from './PlantDashboard';
import CorporateDashboard from './CorporateDashboard';

/**
 * Role-based Dashboard Router
 * 
 * Routes based on user's roleName from JWT/localStorage:
 *  - Operator, Supervisor, Plant Head → PlantDashboard
 *  - Corporate Manager, Director, Super Admin → CorporateDashboard
 *  - Other roles → PlantDashboard (default)
 */

const CORPORATE_ROLES = [
  'super admin',
  'corporate manager',
  'director',
  'admin',
  'management',
];

const DashboardRouter = () => {
  const user = authService.getUser();
  const roleName = (user?.roleName || user?.RoleName || '').toLowerCase().trim();

  // Determine which dashboard to show
  const isCorporate = CORPORATE_ROLES.some(r => roleName.includes(r));

  if (isCorporate) {
    return <CorporateDashboard />;
  }

  return <PlantDashboard />;
};

export default DashboardRouter;
